export const CONSTANTS = {
  USER_JOURNEY_TITLE_PLACEHOLDER: 'Journey title',
  // USER_JOURNEY_DESCRIPTION_PLACEHOLDER: "Record your wins (both big and small), updates, progress made, lessons learned, and more here",
  USER_JOURNEY_DESCRIPTION_PLACEHOLDER: 'Journey description',
  DASHBOARD_PLACEHOLDER: 'Share an update with your community...',
  NO_BADGES_TEXT: "YOU DON'T HAVE ANY BADGES.",
  START_EARNING_BADGES_TEXT:
    'Start earning bages by completeing education modules.',
  EARN_MORE_TOKEN_TEXT: 'Earn More tokens',
  YOUR_BADGES_TEXT: 'Your Badges',
  JOURNEY_YOUR_CONTACTS: 'Your Contacts',
  JOURNEY_WHATS_NEXT: `What's Next?`,
  JOURNEY_GOALS_CHECKLIST: 'Goals Checklist',
  TOKEN_EXPIRED_MESSAGE: 'Your token is expired. Please Login',
  INVALID_CREDENTIAL: 'Invalid credentials',
  INVALID_USER: 'Invalid user',
  ERROR_MESSAGE: 'Something went wrong. Please try again later',
  ERROR_IMAGE_URL:
    'data:image/png;base64,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',
  LOG_OUT_MESSAGE: 'Logout Successfully',
  FILE_LENGTH_LIMIT: 'Maximum 5 Files should be selected',
  COMMENT_REMOVE_MESSAGE: ' Are you sure to remove this comment ?',
  POST_REMOVE_MESSAGE: ' Are you sure to remove this Post ?',
  BUISNESS_DETAILS: 'Business Details',
  CHOOSE_A_COMMUNITY: 'Choose a Community',
  CHOOSE_A_CATEGORY: 'Choose a Category',
  CHOOSE_MENTOR: 'Choose Mentor',
  REGISTER_MENTOR: 'Register Mentor',
  UPDATE_PROFILE_TEXT: 'Update Profile',
  IMAGE_EXTENSION_ERROR: 'Only Image File Allowed',
  VIDEO_EXTENSION_ERROR: 'Only Video File Allowed',
  PHONE_NUMBER_VALIDATION_ERROR: 'Only 10 Digits is Allowed',
  PASSWORD_VALIDATION_MESSAGE_BCK:
    'Password must have minimum eight characters, at least one letter, one number and one special character i.e(@,$,!,%,*,#,?,&)',
  UN_FOLLOWING_USER_TEXT:
    'Are you Sure to Unfollow.it will be removed from following list',
  JOURNEY_REMOVE_MESSAGE: 'Are you sure to remove this journey',
  LIBERAL_REMOVE: 'Are you sure to remove to thi Liberal',
  REGISTER_ROLE: ['mentor', 'user', 'sponsor'],
  NEWS_TYPE: [
    {
      id: 'normal',
      text: 'Normal',
    },
    {
      id: 'announcement',
      text: 'Announcement',
    },
    {
      id: 'meeting',
      text: 'Meeting',
    },
  ],
  NEWS_STATUS: [
    {
      id: 'latest',
      text: 'Latest',
    },
    {
      id: 'normal',
      text: 'Normal',
    },
  ],
  NO_COMMUNITY_MESSAGE:
    'we are working hard to bring Equiliberty to your community!!',
  LANGUAGE_LIST: ['English', 'Spanish'],
};

export const REGEX_CONSTANTS = {
  ACCEPT_NUMBER: /^[0-9\b]+$/,
  ALL_VIDEO_FORMAT_REGEX:
    /\.(wmv|flv|mkv|mp4|webm|m4v|m4a|m4v|f4v|f4a|m4b|m4r|f4b|mov|3gp|3gp2|3g2|3gpp|3gpp2|ogg|oga|ogv|ogx|wmv|wma|mpg|mpeg)$/i,
  ALL_PHOTO_FORMAT_REGEX: /\.(gif|jpe?g||png|bmp)$/i,
  PASSWORD_VALIDATION_REGEX_BCK:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,32}$/,
  AVOID_SYMBOL: /[^\-]+/,
  VALID_URL_REGEX:
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
  YOUTUBE_URL_REGEX: /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/,
  YOUTUBE_EMBED_URL_REGEX:
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/,
};

export const POP_UP_MODAL_CONSTANTS = {
  EDIT_VISION_POP_MODAL: 'EDIT_VISION_POP_MODAL',
  SOCIAL_SHARE_MODAL: 'SOCIAL_SHARE_MODAL',
  CONFIRMATION_POPUP_MODAL: 'CONFIRMATION_POPUP_MODAL',
  UPDATE_POPUP_MODAL: 'UPDATE_POPUP_MODAL',
  ADD_EDIT_CONTACTS_MODAL: 'ADD_CONTACTS_MODAL',
  UPDATE_JOURNEY_MODAL: 'UPDATE_JOURNEY_MODAL',
  UPDATE_PROFILE_MODAL_IMAGES: 'UPDATE_PROFILE_MODAL_IMAGES',
  AUTH_POPUP_MODAL: 'AUTH_POPUP_MODAL',
  FOLLOWER_FOLLOWING_MODAL: 'FOLLOWER_FOLLOWING_MODAL',
  ADD_EDIT_REMINDER: 'ADD_EDIT_REMINDER',
  ADD_EDIT_TOKEN_TO_WALLET: 'ADD_EDIT_TOKEN_TO_WALLET',
  CHANGE_PASSWORD_MODAL: 'CHANGE_PASSWORD_MODAL',
  LOGIN_MODAL: 'LOGIN_MODAL',
  ADD_EDIT_LIBERAL_LIST: 'ADD_EDIT_LIBERAL_LIST',
  ADD_EDIT_RESOURCE: 'ADD_EDIT_RESOURCE',
  ADD_EDIT_EARN_WALLET: 'ADD_EDIT_EARN_WALLET',
  ADD_EDIT_NEWS: 'ADD_EDIT_NEWS',
  ADD_EDIT_ADMIN_USER: 'ADD_EDIT_ADMIN_USER',
  ADD_EDIT_COMMUNITY: 'ADD_EDIT_COMMUNITY',
  ADD_EDIT_COMMUNITY_POST: 'ADD_EDIT_COMMUNITY_POST',
  ADD_EDIT_ADMIN_CATEGORY: 'ADD_EDIT_ADMIN_CATEGORY',
  CHOOSE_MENTOR_POP_UP_MODAL: 'CHOOSE_MENTOR_POP_UP_MODAL',
  ADD_EDIT_GOAL_POP_MODAL: 'ADD_EDIT_GOAL_POP_MODAL',
  MESSAGE_POP_UP_MODAL: 'MESSAGE_POP_UP_MODAL',
  SEND_TOKEN_MODAL: 'SEND_TOKEN_MODAL',
  QUESTION_POP_UP_MODAL: 'QUESTION_POP_UP_MODAL',
  ZIP_CODE_POP_UP_MODAL: 'ZIP_CODE_POP_UP_MODAL',
  FILE_UPLOAD_MODAL: 'FILE_UPLOAD_MODAL',
  ADD_EDIT_BUISNESS_INFORMATION_MODAL: 'ADD_EDIT_BUISNESS_INFORMATION_MODAL',
  COMMUNITY_STATUS_POP_UP_MODAL: 'COMMUNITY_STATUS_POP_UP_MODAL',
  USER_VISION_MENTOR_BIO_POP_UP_MODAL: 'USER_VISION_MENTOR_BIO_POP_UP_MODAL',
  GOAL_CHECKLIST_POP_UP_MODAL: 'GOAL_CHECKLIST_POP_UP_MODAL',
  ADMIN_APPROVE_MENTOR_POP_UP_MODAL: 'ADMIN_APPROVE_MENTOR_POP_UP_MODAL',
  ADD_EDIT_USER_RESOURCE: 'ADD_EDIT_USER_RESOURCE',
  MAILCHIMP_POP_UP_MODAL: 'MAILCHIMP_POP_UP_MODAL',
};
export const POP_UP_MODAL_HEADER_CONSTANTS = {
  EDIT_USER_PROFILE_VISION: 'Edit user vision',
  EDIT_MENTOR_PROFILE_BIO: 'Edit Bio',
  SOCIAL_SHARE: 'Share',
  CONFIRMATION_HEADER: 'Please Confirm',
  UPDATE_POST_HEADER: 'Update Post',
  ADD_CONTACT: 'Add Contact',
  EDIT_CONTACT: 'Edit Contact',
  UPLOAD_BANNER_IMAGE: 'Upload banner image',
  UPLOAD_USER_IMAGE: 'Upload user image',
  UPLOAD_VISION_IMAGE: 'Upload Vision Video',
  UPDATE_JOURNEY_HEADER: 'Update Journey',
  UPDATE_ENQUIRY: 'Update Enquiry',
  ADD_ENQUIRY: 'Add Enquiry',
  FOLLOWER_LIST: 'Follower List',
  FOLLOWING_LIST: 'Following List',
  UNFOLLOW_USER: 'Are you sure to unfollow',
  ADD_REMINDER: 'Add Reminder',
  UPDATE_REMINDER: 'Update Reminder',
  REMOVE_REMINDER: 'Are you sure to remove this reminder',
  ADD_TOKEN_TO_WALLET: 'Add Token',
  CHANGE_PASSWORD_TEXT: 'Change Password',
  ADD_LIBERAL: 'Add Liberal',
  EDIT_LIBERAL: 'Edit Liberal',
  ADD_RESOURCE: 'Add Resource',
  EDIT_RESOURCE: 'Edit Resource',
  CREATE_WALLET_EARNING: 'Create a way of earning',
  EDIT_WALLET_EARNING: 'Edit a way of earning',
  ADD_NEWS: 'Add News',
  EDIT_NEWS: 'Edit News',
  ADD_USER: 'Add User',
  EDIT_USER: 'Edit User',
  ADD_COMMUNITY: 'Add Community',
  EDIT_COMMUNITY: 'Edit Community',
  ADD_CATEGORY: 'Add Category',
  EDIT_CATEGORY: 'Edit Category',
  ADD_GOAL: 'Add Goal',
  EDIT_GOAL: 'Edit Goal',
  SUCCESS_HEADER: 'Success',
  ERROR_HEADER: 'Error',
  SEND_TOKEN: 'Send Tokens',
  QUESTION_HEADER: 'Question',
  ZIPCODE_MODAL_HEADING: 'Please Enter Zipcode',
  HOME_ABOUT_US_HEADER: 'Choose Video',
  ADD_BUISNESS_INDUSTRY: 'Add Buisness Industry',
  EDIT_BUISNESS_INDUSTRY: 'Edit Buisness Industry',
  THANK_FOR_INTREST: 'Thank you for your interest',
  ADD_USER_RESOURCE: 'Add Resource',
  EDIT_USER_RESOURCE: 'Edit Resource',
  SHARE_TO_COMMUNITY: 'Share To Community',
};
export const API_END_POINTS_CONSTANT = {
  // AUTHORIZATION MODULE ENDPOINTS
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  FORGOT_PASSWORD: `/forgotpassword`,
  RESET_PASSWORD: `/resetpassword`,
  VERIFY_USER: `/verify`,
  GET_USER_PROFILE: '/getUserProfile',
  UPDATE_USER_PROFILE: 'updateUser',
  CHECK_TOKEN: '/check-token',
  RESEND_VERIFICATION: '/resendVerification',
  CHECK_PASSWORD_TOKEN: '/checkPasswordToken',
  SELECTED_MENTOR_CATEGORY: '/selectedMentorCategory',
  UPDATE_MENTOR_CATEGORY: '/updateMentorCategory',
  GET_MENTOR_BY_CATEGORY: '/getMentorsByCategoryId',
  GET_MENTOR_INFO_BY_ID: '/getMentorsById',
  UPDATE_USER_MENTOR: '/updateMentor',
  MODIFY_PASSWORD: '/modifyPassword',
  LIST_MENTOR_COMMUNITY: '/listMentorCommunities',
  GOOGLE_LOGIN: '/googleLogin',
  FACEBOOK_LOGIN: '/facebookLogin',
  SET_USER_ANSWER: '/setUserAnswer',
  GET_QUESTION_SET: '/getQuestionSet',
  GET_USER_ANSWERS: '/getUserAnswer',
  SEARCH_COMMUNITY_BY_ZIPCODE: '/searchedCommunityZip',
  SAVE_USER_PENDING_COMMUNITY: '/saveUserPendingCommunity',
  // DASHBOARD MODULE ENDPOINTS
  GET_ALL_USER_POST: '/getPostData',
  GET_USER_POST: '/getPost',
  CREATE_USER_POST: '/createPost',
  DELETE_USER_POST: '/deletePost',
  ADD_COMMENTS: '/addComment',
  VIEW_COMMENTS: '/viewComments',
  DELETE_COMMENTS: '/deleteComment',
  TOGGLE_lIKE: '/toggleLike',
  VIEW_LIKE_USER_LIST: '/viewLikes',
  GET_NEWS: '/getNews',
  UPDATE_DASHBOARD_POST: '/updatePost',
  GET_LIBERATOR_LIST_BY_CITY: '/getListOfLiberatorCityWise',
  GET_RESOURCE_LIST_BY_CITY: '/getListOfResourcesCityWise',
  GET_COMMUNITY_DATA: '/getCommunityData',
  // COMMON FILE UPLOAD MODULE ENDPOINTS
  SINGLE_FILE_UPLOAD: '/uploadfile',
  MULTIPLE_FILE_UPLOAD: '/uploadMultiple',
  // USER PROFILE MODULE ENPOINTS
  LIST_BUSINESS_INDUSTRIES: '/listBusinessIndustries',
  ADD_BUSINESS_INFORMATION: '/addBusinessInformation',
  GET_BUSINESS_INFORMATION: '/getBusinessInformation',
  UPDATE_BUSINESS_INFORMATION: '/updateBusinessInformation',
  LIST_COMMUNITIES: '/listCommunities',
  ASSIGN_COMMUNITY: '/assignCommunity',
  GET_USER_COMMUNITY: '/getUserCommunity',
  LIST_FOLLOWERS: '/listFollowers',
  LIST_FOLLOWING: '/listFollowingUsers',
  LIST_MENTOR_CATEGORY: '/listMentorCategories',
  TOKEN_PAY_API: '/sendTokenToUser',
  GET_GOAL_IMAGES: '/getGoalImages',
  // MESSAGING MODULE ENPOINT
  TOKBOX_VIDEO_CHAT: '/topBoxVedioChat',
  // JOURNEY
  LIST_USER_JOURNEY: '/getJourney',
  CREATE_USER_JOURNEY: '/createJourney',
  UPDATE_USER_JOURNEY: '/updatePost',
  DELETE_USER_JOURNEY: '/deleteJourney',
  USERS_GOALS: '/userGoals',
  // WALLET MODULE ENDPOINT
  WALLET_LEDGER: '/getLedger',
  TOKEN_SUM: '/getTokenSum',
  ADD_TOKEN: '/addTokenToWallet',
  GET_TOKEN_LIST_FOR_USER: '/tokenListForUsers',
  // CONTACTS PAGE MODULE ENDPOINT
  ADD_CONTACT: '/addContact',
  UPDATE_CONTACT: '/updateContact',
  GET_CONTACT_DETAILS: '/getContact',
  GET_CONTACT_LIST: '/getContacts',
  DELETE_CONTACT: '/deleteContact',
  // ADD ENQUIRY
  ADD_ENQUIRY: '/addEnquiry',
  // USER FOLLOW
  FOLLOW_USER: '/toggleFollow',
  // MESSAGING
  GET_PREVIOUS_CHAT: '/recentMessages',
  GET_PRIVATE_MESSAGE: '/privatemessages',
  NEW_CHAT: '/new',
  REPLY_CHAT: '/reply',
  CREATE_ROOM: '/createRoom',
  ROOM_ID_MESSAGES: '/messages',
  GET_REMAINDER_LIST: '/getRemainderList',
  GET_MENTORS_LIST: '/mentors',
  TOK_BOX_VIDEO_CHAT: '/getTokBoxUserSession',
  GET_TOK_BOX_SESSION: '/tokBoxCreateSession',
  DELETE_TOK_BOX_SESSION: '/deleteTokBoxSessions',
  // LOG OUT
  LOG_OUT: '/logout',
  // REMINDER
  CREATE_REMINDER: '/createReminder',
  UPDATE_REMINDER: '/updateRemainder',
  DELETE_REMINDER: '/deleteRemainder',
  // MENTOR MODULE
  MENTOR_REMINDER_lIST: '/getMentorReminderList',
  MENTOR_ID_BY_EMAIL: '/getMentorsByEmail',
  GET_USER_BY_EMAIL: '/getUsersByEmail',
  // ADMIN MODULE API ENDPOINT
  // ADMIN_ADD_COMMUNITY: '/addCommunity',
  ADMIN_ADD_MENTOR_CATEGORY: '/addMentorCategory',
  ADMIN_ADD_BUISNESS_INDUSTRY: '/addBusinessIndustry',
  ADMIN_DELETE_BUISNESS_INDUSTRY: '/deleteBusinessIndustries',
  ADMIN_UPDATE_BUISNESS_INDUSTRY: '/updateBusinessIndustries',
  ADMIN_ADD_MENTOR: '/addMentor',
  CREATE_LOCAL_LIBERATOR: '/createLocalLiberator',
  GET_LIST_LIBERATOR: '/getListLiberator',
  DELETE_LIBERATOR: '/deleteLiberator',
  UPDATE_LIBERATOR: '/updateLiberator',
  //ADMIN MODULE RESOURCE API ENDPOINT
  CREATE_RESOURCE: '/createResources',
  GET_LIST_RESOURCE: '/getListResources',
  DELETE_RESOURCE: '/deleteResources',
  UPDATE_RESOURCE: '/updateResources',
  // ADMIN WALLET RESOURCE API ENDPOINT
  COMPLETE_TASK_TO_GET_TOKEN: '/completeTasksToGetToken',
  UPDATE_COMPLETE_TASK_TO_GET_TOKEN: '/updateMoneyEntry',
  DELETE_COMPLETE_TASK_TO_GET_TOKEN: '/deleteMoneyEntry',
  // ADMIN NEWS MODULE RESOURCE API ENDPOINT
  CREATE_NEWS: '/createNews',
  ADMIN_GET_ALL_NEWS: '/getAllNews',
  UPDATE_NEWS: '/updateNews',
  DELETE_NEWS: '/deleteNews',
  // ADMIN USERS MODULE RESOURCE API ENDPOINT
  CREATE_ADMIN_USER: '/createUser',
  UPDATE_ADMIN_USER: '/updateAdminUser',
  UPDATE_ADMIN_USER_STATUS: '/updateUserStatus',
  ADMIN_USER_LIST: '/getAllUsers',
  ADMIN_USER_DELETE: '/deleteUser',
  CONVERT_TO_LOCAL_LIBERATOR: '/covertToLocalLiberal',
  // ADMIN COMMUNITY MODULE API ENDPOINTS
  ADMIN_ADD_COMMUNITY: '/addCommunity',
  ADMIN_DELETE_COMMUNITY: '/deleteCommunity',
  ADMIN_UPDATE_COMMUNITY: '/updateCommunity',
  // ADMIN CATEGORY API
  ADMIN_UPDATE_MENTOR_CATEGORY: '/updateMentorCategory',
  ADMIN_DELETE_MENTOR_CATEGORY: '/deleteMentorCategory',
  // ADMIN DASHBOARD MODULE RESOURCE API ENDPOINT
  ADMIN_ANALYTICS: '/getAnalytics',
  // ADMIN USER MODULE RESOURCE API ENDPOINT
  ADMIN_USER_POST_LIST: '/getAllUserPostForAdmin',
  CREATE_GOAL: '/createGoal',
  UPDATE_GOAL: '/updateGoal',
  GET_USER_GOAL: '/getUserGoal',
  DELETE_GOAL: '/deleteGoal',
  SHARE_SOCIAL: '/shareSocial',
  // ADMIN QUESTION ANSWER
  CREATE_QUESTION: '/createQuestion',
  // ADMIN PAGE SETTING
  ADD_VIDEO_FOR_ABOUT_US: '/addVideoForAboutUs',
  ADD_VIDEO_FOR_HOME: '/addVideoForHome',
  GET_VIDEO_HOME: '/getVideoHome',
  GET_VIDEO_LIST: '/getVideoLists',
  REMOVE_ADMIN_IMAGE: '/deleteAdminImages',
  // ADMIN PENDING USER LIST
  PENDING_USER_LIST: '/getPendingUsers',
  // LIBERATOR CHAT
  CREATE_ROOM_FOR_LIBERAL: '/createRoomForLiberal',
  MESSAGE_LIST: '/messagesList',
  RECENT_MESSAGES_LIBERAL: '/recentMessagesLiberal',
};

export const HOME_PAGE_ZIP_CODE = [
  {
    areaName: 'Alief',
    zipCode: 77072,
    lng: 29.69779,
    lat: -95.58519,
    status: true,
  },
  {
    areaName: 'Alief',
    zipCode: 77082,
    lng: 29.72449,
    lat: -95.640002,
    status: true,
  },
  {
    areaName: 'Alief',
    zipCode: 77083,
    lng: 29.694395,
    lat: -95.649569,
    status: true,
  },
  {
    areaName: 'Alief',
    zipCode: 77099,
    lng: 29.670869,
    lat: -95.58599,
    status: true,
  },
  {
    areaName: 'Sharpstown',
    zipCode: 77036,
    lng: 29.701847,
    lat: -95.534537,
    status: true,
  },
  {
    areaName: 'Sharpstown',
    zipCode: 77074,
    lng: 29.687947,
    lat: -95.515725,
    status: true,
  },
  {
    areaName: 'Sharpstown',
    zipCode: 77081,
    lng: 29.712099,
    lat: -95.480935,
    status: true,
  },
  {
    areaName: 'Sharpstown',
    zipCode: 77236,
    lng: 29.707687860357186,
    lat: -95.49672340122756,
    status: true,
  },
  {
    areaName: 'Kashmere',
    zipCode: 77026,
    lng: 29.800187,
    lat: -95.328888,
    status: true,
  },
  {
    areaName: 'Trinity Gardens',
    zipCode: 77028,
    lng: 29.827869,
    lat: -95.287485,
    status: true,
  },
  {
    areaName: 'East Houston',
    zipCode: 77016,
    lng: 29.862532,
    lat: -95.29998,
    status: true,
  },
  {
    areaName: 'East Houston',
    zipCode: 77050,
    lng: 29.902887,
    lat: -95.269296,
    status: true,
  },
  {
    areaName: 'East Houston',
    zipCode: 77028,
    lng: 29.827869,
    lat: -95.287485,
    status: true,
  },
  {
    areaName: 'Homestead',
    zipCode: 77016,
    lng: 29.862532,
    lat: -95.29998,
    status: true,
  },
  {
    areaName: 'Homestead',
    zipCode: 77050,
    lng: 29.902887,
    lat: -95.269296,
    status: true,
  },
  {
    areaName: 'Homestead',
    zipCode: 77028,
    lng: 29.827869,
    lat: -95.287485,
    status: true,
  },
  {
    areaName: 'Acres Home',
    zipCode: 77018,
    lng: 29.826448,
    lat: -95.426267,
    status: true,
  },
  {
    areaName: 'Acres Home',
    zipCode: 77088,
    lng: 29.881487,
    lat: -95.452619,
    status: true,
  },
  {
    areaName: 'Acres Home',
    zipCode: 77091,
    lng: 29.853067,
    lat: -95.435966,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77066,
    lng: 29.957234,
    lat: -95.503258,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77078,
    lng: 29.852397,
    lat: -95.2541,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77022,
    lng: 29.83159,
    lat: -95.379554,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77086,
    lng: 29.919035,
    lat: -95.491607,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77013,
    lng: 29.795268,
    lat: -95.233977,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77049,
    lng: 29.832928,
    lat: -95.14904,
    status: true,
  },
  {
    areaName: 'Northside',
    zipCode: 77067,
    lng: 29.952629,
    lat: -95.446609,
    status: true,
  },
  {
    areaName: 'Aldine',
    zipCode: 77039,
    lng: 29.911171,
    lat: -95.341182,
    status: true,
  },
  {
    areaName: 'Aldine',
    zipCode: 77032,
    lng: 29.987805,
    lat: -95.353412,
    status: true,
  },
  {
    areaName: 'Greenspoint',
    zipCode: 77060,
    lng: 29.935512,
    lat: -95.397624,
    status: true,
  },
  {
    areaName: 'Galena Park',
    zipCode: 77029,
    lng: 29.759665,
    lat: -95.256251,
    status: true,
  },
  {
    areaName: 'South East',
    zipCode: 77061,
    lng: 29.647023,
    lat: -95.276656,
    status: true,
  },
  {
    areaName: 'Sunny Side',
    zipCode: 77033,
    lng: 29.66688,
    lat: -95.335133,
    status: true,
  },
  {
    areaName: 'Sunny Side',
    zipCode: 77051,
    lng: 29.656113,
    lat: -95.378696,
    status: true,
  },
  {
    areaName: 'Southwest',
    zipCode: 77071,
    lng: 29.651728,
    lat: -95.519919,
    status: true,
  },
  {
    areaName: 'Southwest',
    zipCode: 77045,
    lng: 29.635793,
    lat: -95.432889,
    status: true,
  },
  {
    areaName: 'Southwest',
    zipCode: 77085,
    lng: 29.620509,
    lat: -95.485333,
    status: true,
  },
  {
    areaName: 'Southwest',
    zipCode: 77031,
    lng: 29.652205,
    lat: -95.54623,
    status: true,
  },
  {
    areaName: 'Southwest',
    zipCode: 77035,
    lng: 29.655503,
    lat: -95.471663,
    status: true,
  },
  {
    areaName: 'South Park',
    zipCode: 77021,
    lng: 29.69843,
    lat: -95.3569,
    status: true,
  },
  {
    areaName: 'Southside',
    zipCode: 77048,
    lng: 29.618714,
    lat: -95.324221,
    status: true,
  },
  {
    areaName: 'Southside',
    zipCode: 77054,
    lng: 29.68025,
    lat: -95.404913,
    status: true,
  },
  {
    areaName: 'Thirdward',
    zipCode: 77004,
    lng: 29.724893,
    lat: -95.363752,
    status: true,
  },
  {
    areaName: 'Thirdward',
    zipCode: 77003,
    lng: 29.749778,
    lat: -95.345885,
    status: true,
  },
  {
    areaName: 'Thirdward',
    zipCode: 77204,
    lng: 29.726639830769713,
    lat: -95.34814906719768,
    status: true,
  },
  {
    areaName: 'Fifth Ward',
    zipCode: 77020,
    lng: 29.773179,
    lat: -95.314327,
    status: true,
  },
  {
    areaName: 'Fifth Ward',
    zipCode: 22026,
    lng: 30.08468540159028,
    lat: -95.4780559933506,
    status: true,
  },
  {
    areaName: 'Fifth Ward',
    zipCode: 77220,
    lng: 29.773031402948195,
    lat: -95.31251770814737,
    status: true,
  },
  // {
  //     areaName:'New York',
  //     zipCode:10278,
  //     lng:40.71336057071509,
  //     lat:-74.00475647778322,
  //     status:false
  // },
  {
    areaName: 'Atlanta',
    zipCode: 39746,
    lng: 33.74941349040264,
    lat: -84.41456602393633,
    status: false,
  },
  {
    areaName: 'Chicago',
    zipCode: 52338,
    lng: 41.81705479540968,
    lat: -87.61431841536701,
    status: false,
  },
  {
    areaName: 'Washington DC',
    zipCode: 45653,
    lng: 38.889044528608885,
    lat: -77.03584724878395,
    status: false,
  },
  {
    areaName: 'Los Angeles',
    zipCode: 90001,
    lng: 33.974758325979664,
    lat: -118.24778380358532,
    status: false,
  },
  {
    areaName: 'Philadelphia',
    zipCode: 10278,
    lng: 39.967935,
    lat: -75.176073,
    status: false,
  },
  {
    areaName: 'Austin',
    zipCode: 78701,
    lng: 30.274733686621335,
    lat: -97.7402180249088,
    status: false,
  },
  {
    areaName: 'Las Vegas',
    zipCode: 89109,
    lng: 36.11297712277914,
    lat: -115.17351085758781,
    status: false,
  },
  {
    areaName: 'Jacksonville',
    zipCode: 32224,
    lng: 30.26590572973012,
    lat: -81.5071831203528,
    status: false,
  },
  {
    areaName: 'New Orleans',
    zipCode: 70116,
    lng: 29.95741871283443,
    lat: -90.06289935550811,
    status: false,
  },
  {
    areaName: 'Cleveland',
    zipCode: 44113,
    lng: 41.49966795483821,
    lat: -81.69369510475735,
    status: false,
  },
  {
    areaName: 'Cincinnati',
    zipCode: 45214,
    lng: 39.11130600944977,
    lat: -84.52167491692076,
    status: false,
  },
];
